export const queryKeys = {
  user: "user",
  users: "users",
  bid: "bids",
  asset: "assets",
  availableBids: "availableBids",
  eoi: "eoi",
  placeBid: "placeBid",
  roundEOI: "roundEOI",
  myBids: "myBids",
  allBidsByRound: "allBidsByRound",
  bidLeaderBoard: "bidLeaderBoard",
  sla: "sla",
  participation: "participation",
  announcement: "announcement",
  caveat: "caveat",
  templates: "templates",
  maintenance: "maintenance",
  online: "online",
  allRounds: "allRounds",
  pendingWitness: "pendingWitness",
  payment: "payment",
  paid: "paid",
  audit: "audit",
  completed: "completed",
  metrics: "metrics",
  approvers: "approvers",
  tpEvidence: "tpEvidence",
  tpActions: "tpActions",
};
